import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'ws-menu',
  standalone: false,
  templateUrl: './ws-menu.component.html',
  styleUrls: ['./ws-menu.component.css'],
})
export class WsMenuComponent {

  @Input() currentForm: 'Have' | 'Need' | null = null;
  @Input() context!: 'Share' | 'Trade';
  @Output() formChange = new EventEmitter<'Have' | 'Need' | null>();

  openForm(type: 'Have' | 'Need') {
    this.currentForm = type;
    this.formChange.emit(this.currentForm);
  }

  closeForm() {
    this.currentForm = null;
    this.formChange.emit(this.currentForm);
  }

}
